import { StoryblokComponent, storyblokEditable } from "gatsby-source-storyblok"

import SliderSection from "../../../V2/Layouts/SliderSection"

import { Experiment } from "@constants/experiments"
import { useIsExperiment } from "@hooks/experiments"
import { storyblokLinkToYocoLink } from "@utils/storyblok"
import React from "react"

const StoryblokSliderSection = ({
  blok,
}: Storyblok.BlokProps<Storyblok.SliderSection>) => {
  const isCenterSliderCardsExperiment = useIsExperiment(
    Experiment.CENTER_SLIDER_CARDS
  )

  return (
    <SliderSection
      id={blok.id}
      sectionId={blok._uid}
      headingSize={blok.headingSize}
      subheadingText={blok.subheadingText}
      headingText={blok.headingText}
      overrideHeadingColor={blok.overrideHeadingColor}
      cardWidth={blok.cardWidth}
      primaryBackgroundColor={blok.primaryBackgroundColor}
      secondaryBackgroundColor={blok.secondaryBackgroundColor}
      ctaType={blok.ctaType}
      ctaText={blok.ctaText}
      ctaColor={blok.ctaColor}
      trackingEvent={blok.trackingEvent}
      trackingEventKey={blok.trackingEventKey}
      trackingEventValue={blok.trackingEventValue}
      ctaLink={storyblokLinkToYocoLink(blok.ctaLink)}
      autoplay={blok.autoplay}
      centerCardsWhenTheyFit={isCenterSliderCardsExperiment}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    >
      {blok.content.map((content) => (
        <StoryblokComponent
          key={content._uid}
          blok={content}
          isSliderChild={true}
        />
      ))}
    </SliderSection>
  )
}

export default StoryblokSliderSection
